export default () => {
  const $postSlider = $('.post-slider');

  if ($postSlider.length === 0) {
    return;
  }

  $postSlider.on('click', '.post-slider__thumbnail', (e) => {
    e.preventDefault();
    const $currentTarget = $(e.currentTarget);

    if ($currentTarget.hasClass('is-active')) {
      return;
    }

    const $fullImg = $postSlider.find('.post-slider__full');
    const fullImgSrc = $currentTarget.attr('data-full-img');



    $fullImg.attr('src', fullImgSrc);

    $postSlider.find('.post-slider__thumbnail.is-active').removeClass('is-active');
    $currentTarget.addClass('is-active');
  });
};
